import { createSelector } from 'selectors'

import { constant } from './paginator.constant'

const getPaginatioHandlers = () =>
	createSelector<NodeListOf<HTMLSelectElement>>({ selector: constant.selector.paginationHandler }, true)

const getItemsPerPageParameterIds = () =>
	createSelector<NodeListOf<HTMLSelectElement>>({ selector: constant.selector.itemsPerPageParameterId }, true)

export const selectors = {
	getPaginatioHandlers,
	getItemsPerPageParameterIds,
}
